export default __webpack_public_path__ + "static/media/emurgo.eba0e8fa.svg";